import React, { useState, useEffect } from 'react';

import { SVGBackspace, SVGCircleCheck, SVGArrowRight } from '../components/SVG';
import { SelectSwitch, Button } from '../components/Control';

function MoneyInputButton({type = 'number', label = '0', onClick = () => {}, onHold = () => {}}){

    const handleHold = (e, onHold) => {
        // Prevent default to avoid unexpected behavior on mobile
        e.preventDefault();

        // Set timeout for hold action
        const holdTimeout = setTimeout(onHold, 400);

        // Cleanup timeout on release
        const clearHoldTimeout = () => clearTimeout(holdTimeout);
        document.addEventListener('mouseup', clearHoldTimeout, { once: true });
        document.addEventListener('mouseleave', clearHoldTimeout, { once: true });
        document.addEventListener('touchend', clearHoldTimeout, { once: true });
        document.addEventListener('touchcancel', clearHoldTimeout, { once: true });
    }

    return (
        <button 
            onClick={onClick} 
            onMouseDown={(e) => handleHold(e, onHold)}
            onTouchStart={(e) => handleHold(e, onHold)}
            className='h-16 flex justify-center items-center bg-slate-100 active:bg-slate-200 dark:bg-slate-800 dark:active:bg-slate-700 rounded-lg ring-1 ring-black/10 ring-inset dark:ring-white/10'
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400, damping: 30 }}
        >
            {type === 'number' ? <span className='text-xl font-medium text-slate-900 dark:text-white'>{label}</span> : null}
            {type === 'backspace' ? <SVGBackspace classes={'h-5 fill-slate-900 dark:fill-white'}/> : null}
            {type === 'enter' ? <SVGCircleCheck classes={'h-5 fill-slate-900 dark:fill-white'}/> : null}
        </button>
    );
}

function MoneyInput(){
    const [value, setValue] = useState(0);
    const [enteredValue, setEnteredValue] = useState('');
    //const formattedValue = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
    const [formattedValue, setFormattedValue] = useState('£0.00');

    const calculateValue = (enteredValue) => {
        const newValue = parseFloat(enteredValue) / 100;
        if (newValue > 0) {
            setValue(newValue);
            setFormattedValue(new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(newValue));
        } else {
            setEnteredValue('');
            setValue(0);
            setFormattedValue('£0.00');
        }
        console.log('Value:', value);
        console.log('Entered Value:', enteredValue);
        console.log('Formatted Value:', formattedValue);
    }

    const handleButtonClick = (buttonValue) => {
        let newEnteredValue = enteredValue + buttonValue;
        if(newEnteredValue > 999999){
            newEnteredValue = '999999';
        }
        setEnteredValue(newEnteredValue);
        calculateValue(newEnteredValue);
    }
    

    const handleBackspace = () => {
        let newEnteredValue = enteredValue.toString().slice(0, -1);
        setEnteredValue(newEnteredValue);
        calculateValue(newEnteredValue);
    }

    const handleHoldBackspace = () => {
        setEnteredValue('');
        calculateValue('');
    }

    return (
        <>
        <div className='flex items-center justify-center bg-slate-50 dark:bg-slate-950 rounded-lg p-3'>
            <span className={`text-[2.6em] leading-[1em] dark:text-white ${!enteredValue ? 'money-pulse' : ''}`}>{formattedValue}</span>
        </div>
        <div className='grid grid-cols-3 gap-1'>
            <MoneyInputButton label={'1'} onClick={() => handleButtonClick(1)} />
            <MoneyInputButton label={'2'} onClick={() => handleButtonClick(2)} />
            <MoneyInputButton label={'3'} onClick={() => handleButtonClick(3)} />
            <MoneyInputButton label={'4'} onClick={() => handleButtonClick(4)} />
            <MoneyInputButton label={'5'} onClick={() => handleButtonClick(5)} />
            <MoneyInputButton label={'6'} onClick={() => handleButtonClick(6)} />
            <MoneyInputButton label={'7'} onClick={() => handleButtonClick(7)} />
            <MoneyInputButton label={'8'} onClick={() => handleButtonClick(8)} />
            <MoneyInputButton label={'9'} onClick={() => handleButtonClick(9)} />
            <MoneyInputButton type={'backspace'} onClick={() => handleBackspace()} onHold={() => handleHoldBackspace()} />
            <MoneyInputButton label={'0'} onClick={() => handleButtonClick(0)} />
            <MoneyInputButton label={'00'} onClick={() => handleButtonClick('00')} />
            {/* <MoneyInputButton type={'enter'} /> */}
        </div>
        </>
    );
}

export default function TransactionNew() {
    const [transactionType, setTransactionType] = useState('spending');

    return (
        <div className='flex flex-col gap-6'>
            <SelectSwitch options={[
                {label: 'Spending', value: 'spending'},
                {label: 'Receiving', value: 'receiving'}
            ]} setValue={setTransactionType} currentValue={transactionType} />
            <MoneyInput />
            <div className='flex items-center justify-center gap-2'>
                <Button label='Add to Bucket' className='w-full' />
                <Button label='Add to Category' className='w-full' />
            </div>
            <div className='flex items-center justify-center gap-2'>
                <Button type='primary' label='Continue' className='w-full' icon={SVGArrowRight} iconPosition='right' />
            </div>
        </div>
    );
}